import { styled } from "../../theme";
import { MediaImage } from "../../types";

export const MainMenuStyle = styled.div`
  width: calc(100vw * 0.82);
  box-sizing: border-box;
  min-height: 100%;
  height: 100%;
  flex-grow: 1;
  box-sizing: border-box;
  display: flex;
  margin-left: auto;
  margin-right: auto;
  flex-direction: row;
  justify-content: flex-end;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    width: calc(100vw * 0.9);
    flex-direction: column;
    justify-content: center;
    height: inherit;
    padding-right: inherit;
  }
`;
export const MainMenuWrapper = styled.div`
  width: 65%;
  display: flex;
  justify-content: flex-end;
  box-sizing: border-box;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    width: 100%;
    flex-direction: column;
    justify-content: center;
    height: inherit;
    padding-right: inherit;
  }
`;

export const MainMenuContainerStyle = styled.div<{ autoWidth: number }>`
  box-sizing: border-box;
  width: ${({ autoWidth }) => `${autoWidth}px`};
  min-height: 100%;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    width: 100%;
    max-width: inherit;
    padding-top:1em;
  }
`;
